// SPDX-License-Identifier: Apache-2.0
import BaseLayer from '../../models/layers/baselayer';

export default class LayersConfig {
  public layersList: BaseLayer[] = [];
  public isSnappingActive = false;
}
